module.exports = __webpack_public_path__ + "static/media/medocs_01_full.cbb5bd55.gif";